import { NavLink } from 'react-router-dom'
import css from 'classnames'
import { NavLinksSVG, ToolTip } from '~/shared/ui'
import { Props } from './types'
import { ExpressOrderIndicator } from '~/features/express-order-indicator'

type IconType =
  | 'settings'
  | 'dashboard'
  | 'person'
  | 'notifications'
  | 'stores'
  | 'orders'
  | 'warehouse'
  | 'activity'
export const NavigationLink = ({
  text,
  link,
  isOpen,
  icon,
  className,
  activeClass = '',
  badgeContent,
  badgeIndicator = undefined,
}: Props) => {
  const linkNode = (
    <NavLink
      className={({ isActive }) => {
        return css(
          'flex relative hover:bg-slate-50 p-3 rounded transition-all items-center gap-4 text-md',
          { [activeClass]: isActive },
          { '[&>span]:text-blue-600': isActive },
          { '[&~div]:opacity-100': isActive },
          { '[&~span]:opacity-100': isActive },
          className,
        )
      }}
      to={link}
    >
      {icon ? <NavLinksSVG icon={icon as IconType} /> : null}
      <p className={css({ hidden: !isOpen })}>{text}</p>
      {badgeContent !== undefined && isOpen ? (
        <span className="relative ml-auto min-w-[24px] h-[24px] px-2 rounded-full bg-white border border-gray-300 text-[11px] leading-none flex items-center justify-center text-[#242424]">
          {badgeContent}
          {badgeIndicator === 'express' ? (
            <ExpressOrderIndicator
              variant="dot"
              className="absolute -right-0.5 -top-0.5"
            />
          ) : null}
        </span>
      ) : null}
    </NavLink>
  )

  if (!isOpen && text) {
    return (
      <ToolTip
        tooltipText={text}
        wrapperClassName="block w-full"
        minWidth="max-content"
        maxWidth="220px"
        placement="right"
      >
        {linkNode}
      </ToolTip>
    )
  }

  return linkNode
}
